<template>
    <div class="flex-fill">
        <div>
            <img class="pr-2" src="@/assets/svg/menu-dddddd.svg">
            <img
                id="go-back"
                class="pr-2"
                src="@/assets/svg/corner-up-left-dddddd.svg"
                @click="goBack()"
            >
            <img src="@/assets/svg/chervron-right-dddddd.svg">
        </div>
        <div class="services-menu mt-3 pb-3 pr-1 sidemenu">
            <ul
                class="list-group text-uppercase main slide current"
                v-if="navItems.length"
            >
                <li
                    class="list-group-item"
                    v-for="(navItem, index) in navItems"
                    :key="index + 0"
                    @click.stop="goTo(navItem.path)"
                >
                    {{ $t(navItem.name) }}
                    <img data-toggle="modal" data-target="#modal-trip" src="@/assets/svg/plus-ffffff.svg" v-if="navItem.addLink" @click.stop="add(navItem.addLink)">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    navItems: {
      type: Array,
      required: true
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({
        name: 'Services'
      })
      // this.$router.go(-1)
    },
    goTo: function (path) {
      this.$router.push({path: path})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/Static.vue